import BROADCAST_STATES from '../constants/broadcastStates'
import GAME_EVENT_FORM_BROADCAST_FIELDS from '../constants/gameEventFormBroadcastFields'

const EDITABLE_FIELDS_WHEN_LIVE = [
  'endTime',
  GAME_EVENT_FORM_BROADCAST_FIELDS.TEAM_HOME,
  GAME_EVENT_FORM_BROADCAST_FIELDS.TEAM_AWAY,
  GAME_EVENT_FORM_BROADCAST_FIELDS.STREAM_DESTINATION,
  GAME_EVENT_FORM_BROADCAST_FIELDS.STREAM_DESTINATION_2,
  GAME_EVENT_FORM_BROADCAST_FIELDS.IS_ADDITIONAL_STREAM_DESTINATION_ADDED,
  GAME_EVENT_FORM_BROADCAST_FIELDS.THIRD_PARTY_BROADCAST_URL,
  GAME_EVENT_FORM_BROADCAST_FIELDS.TYPE,
  GAME_EVENT_FORM_BROADCAST_FIELDS.AUTO_STOP,
  GAME_EVENT_FORM_BROADCAST_FIELDS.COMMENTARY_MODE,
  GAME_EVENT_FORM_BROADCAST_FIELDS.IS_COMMENTARY_ON,
]

/**
 * Check if broadcast has ended (finished, cancelled, errored, creating, deleting)
 * Use for: logos, team fields - things that CAN be edited while live
 */
export const isBroadcastEnded = (state) => {
  const endedStates = [
    BROADCAST_STATES.finished,
    BROADCAST_STATES.cancelled,
    BROADCAST_STATES.errored,
    BROADCAST_STATES.creating,
    BROADCAST_STATES.deleting,
  ]
  return state && endedStates.includes(state)
}

/**
 * Check if a stream has reached a terminal state (finished, cancelled, errored).
 * Mirrors the backend rule that forbids removing a studio operator from such streams,
 * so the operator picker is locked (read-only) for these states.
 */
export const isStreamTerminal = (state) => {
  const terminalStates = [
    BROADCAST_STATES.finished,
    BROADCAST_STATES.cancelled,
    BROADCAST_STATES.errored,
  ]
  return Boolean(state) && terminalStates.includes(state)
}

/**
 * Check if a form field should be disabled
 * Use for: form fields - locked when broadcast is active (running/paused)
 * Some fields (endTime, stream keys, etc.) remain editable when live
 */
export const isFormFieldDisabled = (state, fieldName) => {
  if (!state || state === BROADCAST_STATES.scheduled) {
    return false
  }

  const isLive = state === BROADCAST_STATES.running || state === BROADCAST_STATES.paused
  if (isLive && EDITABLE_FIELDS_WHEN_LIVE.includes(fieldName)) {
    return false
  }

  return true
}
